import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const { orderId } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Verify with PhonePe status API via backend (source of truth)
        const r = await api.get(`/payments/phonepe/status/${orderId}`);
        if (cancelled) return;
        const ps = r.data?.payment_status || "pending";
        setStatus(ps);
        if (ps === "paid") {
          setTimeout(() => navigate(`/order-success/${orderId}`, { replace: true }), 1200);
        }
      } catch (e) {
        setStatus("failed");
      }
    })();
    return () => { cancelled = true; };
  }, [orderId, navigate]);

  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center" data-testid="payment-return-page">
      {status === "checking" && (
        <>
          <Loader2 className="h-16 w-16 text-[#E65A28] mx-auto animate-spin" />
          <h1 className="font-serif text-4xl text-[#0A192F] mt-6">Verifying your payment...</h1>
          <p className="mt-3 text-[#666]">Please don&apos;t close this window.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 text-green-600 mx-auto" />
          <h1 className="font-serif text-4xl text-[#0A192F] mt-6">Payment successful</h1>
          <p className="mt-3 text-[#666]">Redirecting to your order...</p>
        </>
      )}
      {(status === "failed" || status === "pending") && (
        <>
          <XCircle className="h-16 w-16 text-red-500 mx-auto" />
          <h1 className="font-serif text-4xl text-[#0A192F] mt-6">
            {status === "pending" ? "Payment pending" : "Payment failed"}
          </h1>
          <p className="mt-3 text-[#666]">
            {status === "pending"
              ? "Your payment is being processed. We'll notify you once confirmed."
              : "Something went wrong with your payment. Please try again."}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to={`/order-success/${orderId}`} className="bg-[#0A192F] text-white px-6 py-3 rounded-full font-semibold">View order</Link>
            <Link to="/cart" className="border border-[#0A192F] text-[#0A192F] px-6 py-3 rounded-full font-semibold">Back to cart</Link>
          </div>
        </>
      )}
    </div>
  );
}
